// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tiW1xqz1joa9if_cAeGZ{align-items:center;gap:8px;display:flex}.tiW1xqz1joa9if_cAeGZ .kvYXRJjSEYOPlssxzFWT{background-color:var(--background-primary-inverted-primary);border-radius:16px;justify-content:center;align-items:center;width:16px;height:16px;display:flex}.tiW1xqz1joa9if_cAeGZ .fcg8_uW1vSslomIJpUDC{background:var(--border-neutral-primary);width:1px;height:16px;display:inline-block}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterButtonContent": `tiW1xqz1joa9if_cAeGZ`,
	"count": `kvYXRJjSEYOPlssxzFWT`,
	"divider": `fcg8_uW1vSslomIJpUDC`
};
export default ___CSS_LOADER_EXPORT___;
